module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gc-Da-Ea.2e4ee564.png";